import store from '../store'
import actions from '../store/actions'

export const getLiquidatedDamages = async (contractId) => {
  const liquidatedDamages = await store.dispatch(actions.callApi, {
    url: `contracts/${contractId}/lds`
  })
  return liquidatedDamages
}

export const createOrUpdateLiquidatedDamage = async (data, contractId) => {
  const liquidatedDamage = store.dispatch(actions.callApi, {
    url: data.id ? `contracts/${contractId}/lds/${data.id}` : `contracts/${contractId}/lds`,
    method: data.id ? 'PUT' : 'POST',
    body: data
  })
  return liquidatedDamage
}

export const deleteLiquidatedDamage = async (data) => {
  const { contractId } = data
  const liquidatedDamage = store.dispatch(actions.callApi, {
    url: `contracts/${contractId}/lds/${data.id}`,
    method: 'DELETE'
  })
  return liquidatedDamage
}

export const finalizeLiquidatedDamage = async (data, contractId) => {
  return await createOrUpdateLiquidatedDamage({ ...data, finalized: true }, contractId)
}

export const unlockLiquidatedDamage = async (data, contractId) => {
  return await createOrUpdateLiquidatedDamage({ ...data, finalized: false }, contractId)
}

export const createOrUpdateLiquidatedDamageDate = async (data, contractId) => {
  const { id, liquidatedDamageId } = data
  delete data.liquidatedDamageId
  const date = store.dispatch(actions.callApi, {
    url: id ? `contracts/${contractId}/lds/${liquidatedDamageId}/date/${id}` : `contracts/${contractId}/lds/${liquidatedDamageId}/date`,
    method: id ? 'PUT' : 'POST',
    body: data
  })
  return date
}

export const deleteLiquidatedDamageDate = async (data, contractId) => {
  const { id, liquidatedDamageId } = data
  const date = store.dispatch(actions.callApi, {
    url: `contracts/${contractId}/lds/${liquidatedDamageId}/date/${id}`,
    method: 'DELETE'
  })
  return date
}

export const checkForMilestoneNameDuplicate = (liquidatedDamages, paymentMilestones, name, initialName = '') => {
  const ldMilestonesNames = liquidatedDamages.map(ld => ld.milestoneName).filter(n => n !== initialName)
  const paymentMilestonesNames = paymentMilestones.map(m => m.name)
  const allNames = [...ldMilestonesNames, ...paymentMilestonesNames]
  return allNames.filter(n => n === name).length >= 1
}
